/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Filter_PlaceholderInputs */

const en_portal_scanner_filter_placeholder = /** @type {(inputs: Portal_Scanner_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Senior Frontend Engineer`)
};

const de_portal_scanner_filter_placeholder = /** @type {(inputs: Portal_Scanner_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Senior Frontend Engineer`)
};

const fr_portal_scanner_filter_placeholder = /** @type {(inputs: Portal_Scanner_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Senior Frontend Engineer`)
};

const es_portal_scanner_filter_placeholder = /** @type {(inputs: Portal_Scanner_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Senior Frontend Engineer`)
};

const it_portal_scanner_filter_placeholder = /** @type {(inputs: Portal_Scanner_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Senior Frontend Engineer`)
};

const nl_portal_scanner_filter_placeholder = /** @type {(inputs: Portal_Scanner_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Senior Frontend Engineer`)
};

const pl_portal_scanner_filter_placeholder = /** @type {(inputs: Portal_Scanner_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Senior Frontend Engineer`)
};

const fi_portal_scanner_filter_placeholder = /** @type {(inputs: Portal_Scanner_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Senior Frontend Engineer`)
};

const da_portal_scanner_filter_placeholder = /** @type {(inputs: Portal_Scanner_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Senior Frontend Engineer`)
};

const sv_portal_scanner_filter_placeholder = /** @type {(inputs: Portal_Scanner_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Senior Frontend Engineer`)
};

/**
* | output |
* | --- |
* | "e.g. Senior Frontend Engineer" |
*
* @param {Portal_Scanner_Filter_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_filter_placeholder = /** @type {((inputs?: Portal_Scanner_Filter_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Filter_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_filter_placeholder(inputs)
	if (locale === "fr") return fr_portal_scanner_filter_placeholder(inputs)
	if (locale === "es") return es_portal_scanner_filter_placeholder(inputs)
	if (locale === "it") return it_portal_scanner_filter_placeholder(inputs)
	if (locale === "nl") return nl_portal_scanner_filter_placeholder(inputs)
	if (locale === "pl") return pl_portal_scanner_filter_placeholder(inputs)
	if (locale === "fi") return fi_portal_scanner_filter_placeholder(inputs)
	if (locale === "da") return da_portal_scanner_filter_placeholder(inputs)
	if (locale === "sv") return sv_portal_scanner_filter_placeholder(inputs)
	return en_portal_scanner_filter_placeholder(inputs)
});